import type { IconOwnProps } from '@ps/isp-web-component-library';
import { Icon } from '@ps/isp-web-component-library';
import { FreeBetSb } from '@ps/isp-web-component-library/icons/FreeBetSb';
import classNames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import {
  TXTWCL_Hide_available_promotions,
  TXTWCL_Remove_selected_promotion,
  TXTWCL_Show_available_promotions
} from './PromotionPickerButton.messages.json';
import styles from './PromotionPickerButton.scss';

interface Props extends Pick<IconOwnProps, 'icon' | 'size'> {
  onClick: () => void;
  variant: 'close' | 'open' | 'remove';
}

const PromotionPickerButton: React.FC<Props> = ({ onClick, variant, icon, size }) => {
  const { formatMessage } = useRegulatoryIntl();

  let label = formatMessage(TXTWCL_Show_available_promotions);
  let isExpanded: boolean | undefined = false;

  if (variant === 'close') {
    label = formatMessage(TXTWCL_Hide_available_promotions);
    isExpanded = true;
  } else if (variant === 'remove') {
    label = formatMessage(TXTWCL_Remove_selected_promotion);
    isExpanded = undefined;
  }

  return (
    <button
      data-testid="opportunity-promotion-control"
      type="button"
      className={classNames(styles.promotionButton, {
        [styles.freeBetIcon]: icon === FreeBetSb,
        [styles.promotionOpenButton]: variant === 'open',
        [styles.promotionCloseButton]: variant === 'close',
        [styles.promotionRemoveButton]: variant === 'remove'
      })}
      onClick={onClick}
      aria-expanded={isExpanded}
    >
      <Icon icon={icon} size={size} label={label} />
    </button>
  );
};

export default PromotionPickerButton;
